import { useCallback } from "react";
import { useMutation } from "react-apollo";
import { UPDATE_TRIP_ACTION } from "./queries";
import useErrorHandling from "hooks/useErrorHandling";

const useUpdateTripAction = () => {
  const [mutation] = useMutation(UPDATE_TRIP_ACTION);
  const withErrorHandling = useErrorHandling();

  const mutationWithErrorHandling = useCallback(
    async (variables: {
      trip_id: any;
      action_name: string;
      action_params: any;
    }) => {
      return withErrorHandling(mutation, {
        variables,
      });
    },
    [mutation, withErrorHandling]
  );

  return mutationWithErrorHandling;
};

export default useUpdateTripAction;
